import ProductController from '@/assets/controllers/ProductController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
// import LocaleController from '@/assets/controllers/LocaleController'
// import CRMController from '@/assets/controllers/CRMController'
import Util from '@/assets/libs/util'
import store from '@/store'
// import LocaleController from './LocaleController'

let pagerCode = null
let pedidoComanda = null
let bandeiraCartao = null
let digitalWalletName = null
let comandasAgregadas = []
let appliedDiffPrices = false
let backupCart = []

const getProductPrice = function (product) {
  if ((Util.isTapMode() || Util.isBalancaMode()) && product.itemValue) {
    return product.itemValue
  } else if (Util.isBalancaMode() || product.insertedByEan13) {
    if (Number.isInteger(product.quantity)) {
      return Math.round(product.quantity * product.totalItemPrice * 100) / 100
    }
    return Math.floor(product.quantity * product.totalItemPrice * 100) / 100
  } else {
    return Math.round(product.quantity * product.totalItemPrice * 100) / 100
  }
}

const applyDifferentiatedPrices = function () {
  console.log('Aplicando preços diferenciados')

  const backupCartIsEmpty = backupCart && backupCart.length === 0
  if (backupCartIsEmpty) {
    backupCart = Util.deepCopy(store.getters.getCart)
  }

  try {
    const diffPrices = DifferentiatedPricesController.getDiffPrices()
    setDiffPricesOnCart(diffPrices)
    setAppliedDiffPrices(true)
  } catch (error) {
    console.log(error.message)
    restoreOriginalPrices()
  }
}

const setDiffPricesOnCart = function (diffPrices) {
  store.getters.getCart.forEach(product => {
    // eslint-disable-next-line
    const hasDiffPrice = diffPrices.hasOwnProperty(product.productCode)

    if (hasDiffPrice) {
      console.log(`${product.productName} possui preço diferenciado`)
      const newPrices = diffPrices[product.productCode]
      replacePrices(product, newPrices)
    }

    const hasObservations = product.observations && product.observations.length > 0
    if (hasObservations) {
      handleFatherObservations(product, diffPrices)
    }

    const hasChildProds = product.productCombo && product.productCombo.length > 0
    if (hasChildProds) {
      handleChildNewPrices(product, diffPrices)
    }

    ProductController.priceUpdate(product)
  })
}

const replacePrices = function (product, newPrices) {
  product.addition = newPrices.addition
  product.discount = newPrices.discount
  product.fullPrice = newPrices.fullPrice
  product.price = newPrices.price
}

const handleFatherObservations = function (product, diffPrices) {
  product.observations.forEach(obs => {
    const obsIsProduct = obs.obsProductCode != null
    if (obsIsProduct) {
      // eslint-disable-next-line
      const obsHasDiffPrice = diffPrices.hasOwnProperty(obs.obsProductCode)

      if (obsHasDiffPrice) {
        console.log(`${obs.obsName} possui preço diferenciado`)
        const obsNewPrices = diffPrices[obs.obsProductCode]
        replacePrices(obs, obsNewPrices)
      }
    }
  })
}

const handleChildNewPrices = function (product, diffPrices) {
  product.productCombo.forEach(childProd => {
    // eslint-disable-next-line
    const childHasDiffPrice = diffPrices.hasOwnProperty(childProd.subItemCode)

    if (childHasDiffPrice) {
      const childNewPrices = diffPrices[childProd.subItemCode]
      const applyInCombo = childNewPrices.applyInCombo === 'S'

      if (applyInCombo) {
        console.log(`${childProd.subItemName} possui preço diferenciado`)
        replacePrices(childProd, childNewPrices)
      }
    }

    const hasObservations = childProd.observations && childProd.observations.length > 0
    if (hasObservations) {
      handleChildObservations(childProd, diffPrices)
    }

    const isComboDoCombo = childProd.choosen
    if (isComboDoCombo) {
      handleComboDoComboNewPrices(childProd, diffPrices)
    }
  })
}

const handleChildObservations = function (childProd, diffPrices) {
  childProd.observations.forEach(obs => {
    const obsIsProduct = obs.subItemObsProductCode != null
    if (obsIsProduct) {
      // eslint-disable-next-line
      const obsHasDiffPrice = diffPrices.hasOwnProperty(obs.subItemObsProductCode)

      if (obsHasDiffPrice) {
        const obsNewPrices = diffPrices[obs.subItemObsProductCode]
        const applyInCombo = obsNewPrices.applyInCombo === 'S'

        if (applyInCombo) {
          console.log(`${obs.subItemObsName} possui preço diferenciado`)
          replacePrices(obs, obsNewPrices)
        }
      }
    }
  })
}

const handleComboDoComboNewPrices = function (childProd, diffPrices) {
  const keys = Object.keys(childProd.choosen)

  keys.forEach(key => {
    const keyHasItems = childProd.choosen[key] && childProd.choosen[key].length > 0

    if (keyHasItems) {
      childProd.choosen[key].forEach(comboDoComboChild => {
        // eslint-disable-next-line
        const comboDoComboChildHasDiffPrice = diffPrices.hasOwnProperty(comboDoComboChild.subItemCode)

        if (comboDoComboChildHasDiffPrice) {
          const comboDoComboChildNewPrices = diffPrices[comboDoComboChild.subItemCode]
          const applyInCombo = comboDoComboChildNewPrices.applyInCombo === 'S'

          if (applyInCombo) {
            console.log(`${comboDoComboChild.subItemName} possui preço diferenciado`)
            replacePrices(comboDoComboChild, comboDoComboChildNewPrices)
          }
        }

        const hasObservations = comboDoComboChild.observations && comboDoComboChild.observations.length > 0
        if (hasObservations) {
          handleChildObservations(comboDoComboChild, diffPrices)
        }
      })
    }
  })
}

const restoreOriginalPrices = function () {
  // console.log('Removendo preços diferenciados e aplicando preços gerais')
  // cart = Util.deepCopy(backupCart)
  // backupCart = []
  // setAppliedDiffPrices(false)
  const newCart = Util.deepCopy(backupCart)
  store.dispatch('overrideCart', newCart)
  backupCart = []
  setAppliedDiffPrices(false)
}

const setAppliedDiffPrices = function (booleanValue) {
  appliedDiffPrices = booleanValue
}

const hasAppliedDiffPrices = function () {
  return appliedDiffPrices
}

export default {
  applyDifferentiatedPrices,
  restoreOriginalPrices,
  setAppliedDiffPrices,
  hasAppliedDiffPrices,
  setComanda: (_pedidoComanda) => {
    if (comandasAgregadas.length === 0) {
      pedidoComanda = _pedidoComanda
    }
    comandasAgregadas.push(_pedidoComanda)
  },
  getComanda: () => pedidoComanda,

  getComandasAgregadas: function () {
    return comandasAgregadas
  },

  getMainComandaAgregada: function () {
    if (comandasAgregadas && comandasAgregadas[0]) {
      return comandasAgregadas[0]
    }
    return {}
  },

  filterComanda: function (saleCode) {
    comandasAgregadas = comandasAgregadas.filter(ca => ca.saleCode !== saleCode)
    // cart = cart.filter(ct => ct.comandaNumber !== saleCode)
    const newCart = store.getters.getCart.filter(ct => ct.comandaNumber !== saleCode)
    store.dispatch('overrideCart', newCart)
  },

  getCart: function () {
    return store.getters.getCart
  },

  overrideCart: function (newCart) {
    // cart = newCart
    store.dispatch('overrideCart', newCart)
  },

  getPagerCode: function () {
    return pagerCode
  },

  setPagerCode: function (code) {
    pagerCode = code
    console.log(`pagerCode inserido: ${pagerCode}`)
  },

  getbandeiraCartao: function () {
    return bandeiraCartao
  },

  setbandeiraCartao: function (code) {
    bandeiraCartao = code
  },

  clearbandeiraCartao: function () {
    bandeiraCartao = null
    console.log('Bandeira do Cartão Apagada')
  },

  getDigitalWalletName: function () {
    return digitalWalletName
  },

  setDigitalWalletName: function (name) {
    digitalWalletName = name
  },

  clearDigitalWalletName: function () { // CartController.clearDigitalWalletName()
    digitalWalletName = null
    console.log('Nome da Carteira Digital Apagado')
  },

  isCartEmpty: function () {
    // return cart.length === 0
    return store.getters.isCartEmpty
  },

  calculateItemPrice: function (product) {
    const value = getProductPrice(product)
    return Util.formatMoney(value)
  },

  // Retorna uma String com o valor total do carrinho, formatada no formato de dinheiro
  calculateTotalPrice: function (noServiceTax = false, showDiscount = true) {
    let CRMDiscount = { value: 0 }
    CRMDiscount = CRMDiscount.value
    let totalPrice = 0

    if (!store.getters.getCart || store.getters.getCart.length === 0) {
      return Util.formatMoney(0)
    }

    store.getters.getCart.forEach((product) => {
      totalPrice += getProductPrice(product)
    })
    if (showDiscount && CRMDiscount) {
      totalPrice -= CRMDiscount
    }
    if (comandasAgregadas && comandasAgregadas[0] && comandasAgregadas[0].serviceTax !== null && noServiceTax === false) {
      let serviceTax = comandasAgregadas.map(ca => ca.serviceTax)
      serviceTax = serviceTax.reduce((a, b) => parseFloat(a || '0') + parseFloat(b || '0'), 0)
      if (serviceTax) {
        return `${Util.formatMoney(parseFloat(totalPrice) + parseFloat(serviceTax))}`
      }
    }
    return totalPrice
  },

  getTotalPriceAsFloat: function (noServiceTax = false, showDiscount = true) {
    const cartTotalString = this.calculateTotalPrice(noServiceTax, showDiscount)
    const cartTotal = cartTotalString.replace('R$', '').replace(',', '').replace('.', '').trim()
    return parseFloat(cartTotal) / 100
  },
  decreaseQttyCart: function (prod, key) {
    const cart = store.getters.getCart
    if (cart[key].quantity > 1) {
      store.dispatch('decreaseQtty', key)
    }
  },
  decreaseQtty: function (key, self) {
    // if (cart[key].quantity > 1) {
    //   cart[key].quantity--
    // } else {
    //   this.deleteProduct(key, self)
    // }
    store.dispatch('decreaseQtty', { key, self })
  },

  increaseQtty: function (key) {
    // cart[key].quantity++
    store.dispatch('increaseQtty', key)
  },

  editProduct: function (product) {
    // cart[key] = product
    store.dispatch('editProduct', product)
  },

  navigateToCheckout: function (router) {
    if (store.getters.getCartLength > 0) {
      router.push('checkout')
    }
  },

  navigateToHome: function (router) {
    router.push('home')
  },

  navigateToPayment: function (router) {
    router.push('payment')
  },

  navigateToPager: function (router) {
    router.push('pager')
  },

  fixProdForCart: function (prod) {
    if (!(prod.quantity && prod.unitValue && prod.totalItemPrice && prod.observations) && !prod.productCombo) {
      prod.quantity = prod.quantity || 1
      prod.unitValue = prod.price
      prod.totalItemPrice = prod.itemValue || Util.safeDecimalCalc(prod.unitValue, prod.discount, '-')
      prod.observations = prod.observations || []
      prod.productCombo = prod.productCombo || []
    }

    if (prod.isABox) {
      if (!prod.productCode && prod.subItemCode) prod.productCode = prod.subItemCode
      if (!prod.productName && prod.subItemName) prod.productName = prod.subItemName
      if (!prod.productPrint && prod.subItemProductPrint) prod.productPrint = prod.subItemProductPrint
      if (!prod.productImage && prod.subItemProductImage) prod.productImage = prod.subItemProductImage
      if (!prod.productImages && prod.subItemProductImages) prod.productImages = prod.subItemProductImages
    }

    return prod
  },

  addToCart: function (prod) {
    // prod.index = cart.length - 1
    // cart.push(this.fixProdForCart(prod))
    // console.log('cart', cart)
    // console.log(this.fixProdForCart(prod))
    const fixedProd = this.fixProdForCart(prod)
    store.dispatch('addToCart', fixedProd)
  },

  // Esta funcao é usada para limpeza de carrinho decorrente de acoes do usuario
  clearCart: function (self, route) {
    // Util.showConfirmationDialog(self.$modal, () => {
    //   cart = []
    //   backupCart = []
    //   pagerCode = null
    //   self.$router.push(route)
    // }, LocaleController.getString('deseja_limpar_carrinho'))
    store.dispatch('clearCart', { self, route })
  },

  // Esta funcao é usada para limpeza de carrinho decorrente de acoes do sistema
  resetCart: function () {
    // cart = []
    // backupCart = []
    pagerCode = null
    comandasAgregadas = []
    store.dispatch('resetCart')
  },

  clearCartAndNavigateHome (router) {
    this.resetCart()
    router.push('/')
  },

  deleteProduct: function (key, self) {
    // const message = LocaleController.getString('certeza_que_deseja_remover') + `${cart[key].productName}` + LocaleController.getString('do_carrinho')
    // Util.showConfirmationDialog(self.$modal, () => {
    //   cart.splice(key, 1)
    //   if (this.isCartEmpty()) {
    //     self.$router.push('Home')
    //   } else {
    //     self.$emit('reloadPrice')
    //   }
    // }, message)
    store.dispatch('deleteProduct', { key, self })
  }
}
